<template>
    <v-expansion-panels
        class   = "mb-1"
        v-model = "filterExpand"
        @change = "onFilterExpand"
        accordion
        flat
    >
        <v-expansion-panel class="pa-0" :key="1" >
            <v-expansion-panel-header
                :ripple     = "false"
                expand-icon = ""
                class       = "pa-0"
            >
                <c-column-header label = "Meldungen" class = "primary mt-3 ml-4 mr-3 mb-0">
                    <template v-slot:filter>
                        <c-item-count :count="count" v-if="messages" />
                        <div>
                            <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>

                            <a
                                @click.stop = "onRemoveFilter"
                                v-show      = "filterIsOn"
                            >
                                <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                            </a>
                        </div>
                    </template>
                </c-column-header>
            </v-expansion-panel-header>

            <v-expansion-panel-content eager class="pa-0 ma-0" style="padding-right: 10px!important;">
                <div class="ml-4 mt-1" style="height: 240px; width: calc(100% - 16px)">
                    <v-row dense class="lm-border mt-2">
                        <v-col>
                            <v-checkbox
                                v-model = "filter.success"
                                :ripple = "false"
                                class   = "mt-0"
                                hide-details
                            >
                                <template v-slot:label>
                                    <c-tag
                                        background-color = "success"
                                        :active          = "true"
                                        label            = "vollständig"
                                        class            = "quality-tag"
                                    />
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox
                                v-model = "filter.warning"
                                :ripple = "false"
                                class   = "mt-0"
                                hide-details
                            >
                                <template v-slot:label>
                                    <c-tag
                                        background-color = "warning"
                                        :active          = "true"
                                        label            = "zu prüfen"
                                        class            = "quality-tag"
                                    />
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox
                                v-model = "filter.error"
                                :ripple = "false"
                                class   = "mt-0"
                                hide-details
                            >
                                <template v-slot:label>
                                    <c-tag
                                        background-color = "error"
                                        :active          = "true"
                                        label            = "fehlerhaft"
                                        class            = "quality-tag"
                                    />
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row dense class="lm-border mt-2 pa-2 pt-0">
                        <v-col class="no-frame">
                            <v-row dense>
                                <v-col class="no-frame col-12">
                                    <v-text-field
                                        v-model        = "filter.text"
                                        class          = "search mb-0"
                                        clear-icon     = "mdi-close-circle"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                        append-icon    = "fas fa-search"
                                        hide-details
                                        dense
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col class="pr-2 col-6">
                                    <f-enum-select
                                        v-model   = "filter.messagetype"
                                        label     = "Meldungsart"
                                        module    = "inb"
                                        type      = "messageTypes"
                                        clearable
                                        hide-details
                                    />
                                </v-col>
                                <v-col class="pl-2 col-6">
                                    <f-enum-select
                                        v-model   = "filter.invoicetype"
                                        label     = "Rechnungsart"
                                        module    = "inb"
                                        type      = "invoiceTypes"
                                        style="max-width: 200px!important;"
                                        clearable
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row dense class="lm-border mt-2">
                        <v-col>

                            <v-checkbox
                                v-model = "filter.confirmed"
                                :ripple = "false"
                                class   = "mt-0"
                                hide-details
                                @click = "onConfirmed"
                            >
                                <template v-slot:label>
                                    <div style="margin-left: -5px;margin-top: -3px">
                                        erledigt
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox
                                v-model = "filter.unconfirmed"
                                :ripple = "false"
                                class   = "mt-0"
                                @click = "onUnconfirmed"
                                hide-details
                            >
                                <template v-slot:label>
                                    <div style="margin-left: -5px;margin-top: -3px">
                                        noch nicht erledigt
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox
                                v-model = "filter.removed"
                                :ripple = "false"
                                class   = "mt-0"
                                hide-details
                                @click = "onDeleted"
                            >
                                <template v-slot:label>
                                    <div style="margin-left: -5px;margin-top: -3px">
                                        gelöscht
                                    </div>
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox
                                v-model  = "filter.lastDay"
                                :ripple  = "false"
                                class    = "mt-0"
                                hide-details
                                @click   = "onLastDay"
                            >
                                <template v-slot:label>
                                    <div style="margin-left: -5px;margin-top: -3px">
                                        letzte 24 Stunden
                                    </div>
                                </template>
                            </v-checkbox>
                            <v-checkbox
                                v-model = "filter.uploads"
                                :ripple = "false"
                                class   = "mt-0"
                                hide-details
                            >
                                <template v-slot:label>
                                    <div style="margin-left: -5px;margin-top: -3px">
                                        Datei Uploads
                                    </div>
                                </template>
                            </v-checkbox>
                            <v-checkbox
                                v-model = "filter.mails"
                                :ripple = "false"
                                class   = "mt-0"
                                hide-details
                            >
                                <template v-slot:label>
                                    <div style="margin-left: -5px;margin-top: -3px">
                                        Mails
                                    </div>
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>

import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";
import CItemCount from "@/modules/core/components/utils/CItemCount";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import CTag from "@/modules/core/components/utils/CTag";
import { applyFilter, isFilterActive, DEFAULT_FILTER } from "@/modules/inb/service/inboxFilter";

export default {
    name: "CInboxFilter",
    components: {
        CTag,
        FEnumSelect,
        CItemCount,
        CColumnHeader
    },

    props: {
        messages: {},
        allMode : {
            type   : Boolean,
            default: false,
        },
    },

    data: () => ({
        myCustomers: false,
        filterIsOn : false,
        filterExpand: null,
        count: 0,
        filter: JSON.parse(JSON.stringify(DEFAULT_FILTER)),
    }),

    computed: {
        availableCustomers () {
            if (!this.messages) return [];
            const seen = new Set();
            return this.messages
                .filter(m => m.customer)
                .filter(m => {
                    if (seen.has(m.customer.id)) return false;
                    seen.add(m.customer.id);
                    return true;
                })
                .map(m => m.customer)
                .sort((a, b) => a.name.localeCompare(b.name));
        },
    },

    watch: {
        filter: {
            deep: true,
            handler: function () {
                this.onFilterChanged();
            }
        },
        messages () {
            this.onFilterChanged();
        },
        allMode (val) {
            if (val) {
                this.filter.lastDay  = true;
                this.filter.customer = null;
            } else {
                this.filter.lastDay  = false;
                this.filter.customer = null;
            }
        },
    },

    methods: {
        onFilterExpand () {
            this.$emit("expand", this.filterExpand === 0);
        },

        onConfirmed () {
            this.$emit("reload", this.filter);
        },

        onDeleted () {
            this.$emit("reload", this.filter);
        },

        onUnconfirmed () {
            this.$emit("reload", this.filter);
        },

        onLastDay () {
            this.$emit("reload", this.filter);
        },

        onFilterChanged () {
            this.filterIsOn = isFilterActive(this.filter);
            const filtered  = applyFilter(this.messages, this.filter);
            this.count      = filtered.length;
            this.$emit("changed", filtered);
        },

        onRemoveFilter () {
            this.clearFilter();
            this.filterIsOn = isFilterActive(this.filter);
            this.$emit("reload", this.filter);
        },

        getFilter () {
            return this.filter;
        },

        clearFilter () {
            this.filter = JSON.parse(JSON.stringify(DEFAULT_FILTER));
        },
    }
}
</script>

<style scoped>

.quality-tag {
    width: 80px!important;
    margin-left: -6px;
    margin-top: 0!important;
}

</style>